import { render } from "./AddAddressModal.vue?vue&type=template&id=66e3afc6&scoped=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=js"
export * from "./AddAddressModal.vue?vue&type=script&lang=js"

import "./AddAddressModal.vue?vue&type=style&index=0&id=66e3afc6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e3afc6"]])

export default __exports__